import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="w-full bg-bg-alt py-6 md:py-10 px-4 sm:px-6 lg:px-8" data-id="element-84">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <h2 className="text-[32px] md:text-[36px] font-bold text-text-primary mb-2.5 leading-[1.2]" data-id="element-87">
            Your Family Deserves to Know What They're Breathing.
          </h2>
          <p className="text-[18px] text-text-secondary mb-6" data-id="element-88">
            4,800+ families already stopped guessing. Tonight could be the night
            that matters.
          </p>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto bg-accent-orange hover:bg-[#FF6E38] text-white font-bold text-[18px] uppercase py-[20px] px-[48px] rounded-lg transition-colors duration-300 mb-4" data-id="element-89">
            PROTECT MY FAMILY NOW →
          </button>
          <div className="text-[14px] text-text-secondary font-medium" data-id="element-90">
            🔒 Free Shipping · 30-Day Money-Back · 3-Year Warranty
          </div>
        </motion.div>
      </div>
    </section>;
}